import { actions, selectors } from 'data'
import React, { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import TierTwo from './template'

type PropsType = ConnectedProps<typeof connector>

const TierTwoContainer = ({
  getCountries,
  handleSubmit,
  initialValues,
  isLoading,
  isUS,
  pollUser,
  step
}: PropsType) => {
  useEffect(() => {
    getCountries()
  }, [])

  return (
    <TierTwo
      handleSubmit={(e) => {
        if (e) e.preventDefault()
        handleSubmit(step)
        pollUser()
      }}
      initialValues={initialValues}
      isLoading={isLoading}
      isUS={isUS}
      step={step}
    />
  )
}

const mapStateToProps = (state) => {
  const user = selectors.auth.getUser(state)

  return {
    initialValues: selectors.tierTwo.getValuesOrInitial(state),
    isLoading: selectors.tierTwo.isLoading(state),
    isUS: user && user.address ? user.address.country === 'US' : false,
    step: selectors.tierTwo.getStep(state)
  }
}

const mapDispatchToProps = (dispatch) => ({
  getCountries: () => {
    dispatch(actions.app.getCountries())
  },
  handleSubmit: (step) => {
    dispatch(actions.tierTwo.submit(step))
  },
  pollUser: () => {
    dispatch(actions.auth.pollUser())
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(TierTwoContainer)
